import { __module as e } from "../../../_virtual/isWhitelisted.js";
import { a as t } from "./util/assertString.js";
Object.defineProperty(r = e.exports, "__esModule", {
  value: !0
}), r.default = function (e, t) {
  (0, s.default)(e);
  for (var r = e.length - 1; r >= 0; r--) if (-1 === t.indexOf(e[r])) return !1;
  return !0;
}, s = t && t.__esModule ? t : {
  default: t
}, e.exports = r.default, e.exports.default = r.default;
var r,
  s,
  i = e.exports;
export { i };